import React, { Fragment } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Badge } from 'reactstrap';
import Api from '../../api/api';
import OverlayLoading from '../common/overlay-loading';

export default class Rewards extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            modal: false,
            id: null,
            form: {
                reward: '',
                disable: 'FALSE',
            },
            rewards: [],
            totalItems: 0,
            currentPage: 0,
            pageSize: 20,
            search: '',
            orderBy: 'balance',
            orderDirection: 'desc',
        };
    }

    componentDidMount = () => {
        this.updateTable();
    }

    updateTable = async () => {
        const { orderBy, orderDirection, search, currentPage, pageSize } = this.state;

        await this.setState({ loading: true });

        // Fetching count
        let countResponse = await Api.get('rewards/count', {
            where: search ? { address: { like: `%${search}%` } } : {},
        });

        if (!countResponse.error) {
            this.setState({ totalItems: countResponse.data.count });
        }

        // Fetching rewards with pagination
        let req = await Api.get('rewards', {
            order: `${orderBy} ${orderDirection}`,
            limit: pageSize,
            offset: currentPage * pageSize,
            where: search ? { address: { like: `%${search}%` } } : {},
        });

        if (!req.error) {
            this.setState({ rewards: req.data });
        }

        await this.setState({ loading: false });
    }

    deleteRow = async (id) => {
        let response = window.confirm("ATTENTION!!! This action cannot be undone.");
        if (response) {
            let req = await Api.del(`rewards/${id}`);
            if (!req.error) {
                this.updateTable();
                this.setState({ modal: false })
            }
        }
    }

    openRow = (row) => {
        this.setState({
            modal: true,
            id: row.id,
            form: {
                reward: (parseFloat(row.reward) / 1e9).toFixed(9),
                disable: row.disable ? 'TRUE' : 'FALSE',
            }
        })
    }

    saveRow = async () => {
        await this.setState({ loading: true });
        let form = {
            reward: (parseFloat(this.state.form.reward) * 1e9).toFixed(0),
            disable: this.state.form.disable === 'TRUE',
        };
        await Api.patch(`rewards/${this.state.id}`, form)
        this.updateTable();
        this.setState({ modal: false, loading: false })
    }

    handleChange = (event) => {
        let form = this.state.form;
        form[event.target.name] = event.target.value;
        this.setState({ form });
    }

    toggleModal = () => {
        this.setState({ modal: !this.state.modal });
    }

    toggleSort = (column) => {
        const { orderBy, orderDirection } = this.state;
        const newDirection = orderBy === column && orderDirection === 'asc' ? 'desc' : 'asc';
        this.setState({ orderBy: column, orderDirection: newDirection }, this.updateTable);
    }

    changePage = (pageNum) => {
        this.setState({ currentPage: pageNum }, this.updateTable);
    }

    render() {
        const { rewards, currentPage, pageSize, totalItems, loading, orderBy, orderDirection } = this.state;
        const totalPages = Math.ceil(totalItems / pageSize);

        const renderSortIcon = (column) => {
            if (orderBy === column) {
                return orderDirection === 'asc' ? ' 🔼' : ' 🔽';
            }
            return null;
        };

        return (
            <Fragment>
                <OverlayLoading show={loading} />
                <div className="container-fluid pt-5">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <h5>Rewards</h5>
                                </div>
                                <div className="row mb-2 mt-2">
                                    <div className="col-sm-6">
                                        <button className="btn" onClick={() => this.changePage(0)} hidden={currentPage === 0}>{'<<'}</button>
                                        <button className="btn" onClick={() => this.changePage(currentPage - 1)} hidden={currentPage === 0}>{'<'}</button>
                                        <button className="btn">Page {currentPage + 1} of {totalPages}</button>
                                        <button className="btn" onClick={() => this.changePage(currentPage + 1)} hidden={currentPage + 1 >= totalPages}>{'>'}</button>
                                        <button className="btn mr-auto" onClick={() => this.changePage(totalPages - 1)} hidden={currentPage + 1 >= totalPages}>{'>>'}</button>
                                    </div>
                                    <div className="col-sm-4">
                                        <input type="text" placeholder="Search by Address"
                                            className="form-control"
                                            onChange={(e) => this.setState({ search: e.target.value })}
                                            value={this.state.search || ''} />
                                    </div>
                                    <div className="col-sm-2">
                                        <button className="btn btn-primary" onClick={this.updateTable}>Apply</button>
                                    </div>
                                </div>
                                <table className="table table-hover">
                                    <thead>
                                        <tr>
                                            <th style={{ cursor: 'pointer' }} onClick={() => this.toggleSort('balance')}>Balance{renderSortIcon('balance')}</th>
                                            <th style={{ cursor: 'pointer' }} onClick={() => this.toggleSort('reward')}>Reward{renderSortIcon('reward')}</th>
                                            <th style={{ cursor: 'pointer' }} onClick={() => this.toggleSort('disable')}>Enable{renderSortIcon('disable')}</th>
                                            <th style={{ cursor: 'pointer' }} onClick={() => this.toggleSort('address')}>Address{renderSortIcon('address')}</th>
                                            <th>Edit</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rewards.map((row, index) => (
                                            <tr key={index}>
                                                <td>{(parseFloat(row.balance) / 1e9).toFixed(3)} LIGHT</td>
                                                <td>{(parseFloat(row.reward) / 1e9).toFixed(3)} LIGHT</td>
                                                <td>{row.disable ? <Badge color='danger'>Disabled</Badge> : <Badge color='success'>Enabled</Badge>}</td>
                                                <td>{row.address}</td>
                                                <td>
                                                    <button className="btn btn-primary" onClick={() => this.openRow(row)}>Edit</button>
                                                    {' '}
                                                    <button className="btn btn-danger" onClick={() => this.deleteRow(row.id)}>Delete</button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <div className="d-flex justify-content-center mb-4">
                                    <button className="btn ml-auto" onClick={() => this.changePage(0)} hidden={currentPage === 0}>{'<<'}</button>
                                    <button className="btn" onClick={() => this.changePage(currentPage - 1)} hidden={currentPage === 0}>{'<'}</button>
                                    <button className="btn">Page {currentPage + 1} of {totalPages}</button>
                                    <button className="btn" onClick={() => this.changePage(currentPage + 1)} hidden={currentPage + 1 >= totalPages}>{'>'}</button>
                                    <button className="btn mr-auto" onClick={() => this.changePage(totalPages - 1)} hidden={currentPage + 1 >= totalPages}>{'>>'}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal isOpen={this.state.modal} toggle={this.toggleModal} size="lg" centered>
                    <ModalHeader toggle={this.toggleModal}>Edit Reward</ModalHeader>
                    <ModalBody>
                        <div className="row">
                            <div className="col-md">
                                <div className="form-group">
                                    <label>Reward</label>
                                    <input className="form-control"
                                        type="text"
                                        name="reward"
                                        value={this.state.form.reward}
                                        onChange={this.handleChange} />
                                </div>
                            </div>
                            <div className="col-md">
                                <div className="form-group">
                                    <label>Disabled</label>
                                    <select className="form-control digits"
                                        name="disable"
                                        value={this.state.form.disable}
                                        onChange={this.handleChange}>
                                        <option>{"TRUE"}</option>
                                        <option>{"FALSE"}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        {this.state.id && <button className="btn btn-danger" style={{ marginRight: 'auto' }} onClick={() => this.deleteRow(this.state.id)}>Delete</button>}
                        <button className="btn btn-primary" onClick={this.saveRow}>Save</button>
                        <button className="btn btn-secondary" onClick={this.toggleModal}>Cancel</button>
                    </ModalFooter>
                </Modal>
            </Fragment>
        );
    }
}
